var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTelegramDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6663 19.9997C36.6663 29.2044 29.2044 36.6663 19.9997 36.6663C10.7949 36.6663 3.33301 29.2044 3.33301 19.9997C3.33301 10.7949 10.7949 3.33301 19.9997 3.33301C29.2044 3.33301 36.6663 10.7949 36.6663 19.9997ZM21.4929 15.23L10.2694 19.8543C8.29446 20.625 9.45052 21.3475 9.45052 21.3475C9.45052 21.3475 11.1365 21.9256 12.5815 22.3591C14.0266 22.7926 14.7973 22.3109 14.7973 22.3109L21.5893 17.7348C23.9977 16.0971 23.4197 17.4458 22.8417 18.0238C21.5893 19.2762 19.518 21.2512 17.7839 22.8408C17.0131 23.5152 17.3985 24.0932 17.7357 24.3822C18.7159 25.2116 21.024 26.7197 22.0733 27.4053C22.3646 27.5957 22.5589 27.7227 22.6008 27.7541C22.8417 27.9468 24.1904 28.8138 25.0093 28.6211C25.8282 28.4285 25.9245 27.3206 25.9245 27.3206L27.1287 19.7579C27.2358 19.0489 27.3428 18.3548 27.4426 17.7075C27.7021 16.024 27.9128 14.6574 27.9476 14.1703C28.0921 12.5325 26.358 13.2069 26.358 13.2069C26.358 13.2069 22.6008 14.7483 21.4929 15.23Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTelegramDark);
export default __webpack_public_path__ + "static/media/ic-telegram-dark.434c7151a34bf5642b94257d8f5a94bc.svg";
export { ForwardRef as ReactComponent };